// extracted by mini-css-extract-plugin
export default {"container":"YP-z","topReviewHeading":"ZP-z","criticalReview":"_P-z","favorableReview":"aQ-z","vsSeparator":"bQ-z"};